import React, { useEffect } from "react";
import MetaTag from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";

// Components
import { HomePageBanner } from "./Components/01-Banner";
import { HomePageIntroSection } from "./Components/02-IntroSection";
import { HomePageInfoIconsSection } from "./Components/03-InfoIconsSection";
import { ParticipatingBrands } from "src/Common/Components/ParticipatingBrands";
import { regionGetter } from "src/Services/RegionGetter";
import { ImgLinks } from "src/Common/Components/ParticipatingBrands/Assets/Imgs/index.js";
import { Carousel } from "src/Common/Components/Carousel";
import {
  carouselDataVn,
  carouselHeaderVn,
} from "src/Common/Components/Carousel/Constants/Constants";

import {
  shopeePayVnHomePageURL,
  shopeePayVnHomePageTitle,
  shopeePayVnHomePageContent,
  shopeeImgLink,
  shopeepayVnName,
  vnHrefLang,
  thHrefLang,
  myHrefLang,
  idHrefLang,
  sgHrefLang,
  phHrefLang,
  shopeePayIdHomepageURL,
  shopeePayThHomepageURL,
  shopeePayMyHomePageURL,
  shopeePayPhHomePageURL,
  shopeePaySgHomePageURL
} from "src/Common/SEO";
import {
  getGoogleSheetData,
  getGoogleSheetPromoBanner,
} from "src/RootRedux/UrlRedux/Actions";

const HomePage = () => {
  const region = regionGetter();
  const dispatch = useDispatch();

  const PromoBannerPageReducer = useSelector(
    (state) => state.PromoBannerPageReducer
  );
  const promoArticleReducer = useSelector(
    (state) => state.PromoArticlePageReducer
  );

  const { promoArticle } = promoArticleReducer;
  const { promoBanner } = PromoBannerPageReducer;

  useEffect(() => {
    // add Breadcrumb Schema
    // add Organisation Schema
    let script = document.createElement("script");
    script.setAttribute("type", "application/ld+json");
    script.text = `{"@context": "https://schema.org",
          "@type": "Organization",
          "name":"${shopeepayVnName}",
          "url": "${shopeePayVnHomePageURL}",
          "logo": "${shopeeImgLink}"}`;
    let head = document.getElementsByTagName("head")[0];
    head.appendChild(script);

    // add href lang
    let linkVn = document.createElement("link");
    linkVn.setAttribute("rel", "alternate");
    linkVn.setAttribute("href", shopeePayVnHomePageURL);
    linkVn.setAttribute("hreflang", vnHrefLang);
    head.appendChild(linkVn);

    // add href lang
    let linkMy = document.createElement("link");
    linkMy.setAttribute("rel", "alternate");
    linkMy.setAttribute("href", shopeePayMyHomePageURL);
    linkMy.setAttribute("hreflang", myHrefLang);
    head.appendChild(linkMy);

    // add href lang
    let linkTh = document.createElement("link");
    linkTh.setAttribute("rel", "alternate");
    linkTh.setAttribute("href", shopeePayThHomepageURL);
    linkTh.setAttribute("hreflang", thHrefLang);
    head.appendChild(linkTh);

    // add href lang
    let linkId = document.createElement("link");
    linkId.setAttribute("rel", "alternate");
    linkId.setAttribute("href", shopeePayIdHomepageURL);
    linkId.setAttribute("hreflang", idHrefLang);
    head.appendChild(linkId);

    let linkSg = document.createElement("link");
    linkSg.setAttribute("rel", "alternate");
    linkSg.setAttribute("href", shopeePaySgHomePageURL);
    linkSg.setAttribute("hreflang", sgHrefLang);
    head.appendChild(linkSg);

    let linkPh = document.createElement("link");
    linkPh.setAttribute("rel", "alternate");
    linkPh.setAttribute("href", shopeePayPhHomePageURL);
    linkPh.setAttribute("hreflang", phHrefLang);
    head.appendChild(linkPh);

    return () => {
      // remove Breadcrumb Schema
      let allScripts = document.getElementsByTagName("script");
      for (let i = allScripts.length; i >= 0; i--) {
        if (allScripts[i] && allScripts[i].getAttribute("type") !== null) {
          allScripts[i].parentNode.removeChild(allScripts[i]);
        }
      }
      let allLinks = document.getElementsByTagName("link");
      for (let i = allLinks.length; i >= 0; i--) {
        if (allLinks[i] && allLinks[i].getAttribute("hreflang") !== null) {
          allLinks[i].parentNode.removeChild(allLinks[i]);
        }
      }
    };
  }, []);

  // useEffect(() => {
  //   if (sessionStorage.getItem("promo-article") === null) {
  //     dispatch(getGoogleSheetData());
  //   } 

  //   if (sessionStorage.getItem("promo-banner") === null) {
  //     dispatch(getGoogleSheetPromoBanner());
  //   } 

  // }, []);

  return (
    <>
      <MetaTag>
        {/* Meta title */}
        <title>{shopeePayVnHomePageTitle}</title>

        {/* Meta description */}
        <meta name="description" content={shopeePayVnHomePageContent} />

        {/* Robots */}
        <meta name="robots" content="index, follow" />

        {/* Canonical */}
        <link rel="canonical" href={shopeePayVnHomePageURL} />

        {/* Open Graph	 */}
        <meta property="og:title" content={shopeePayVnHomePageTitle} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={shopeePayVnHomePageURL} />
        <meta property="og:image" content={shopeeImgLink} />
        <meta property="og:description" content={shopeePayVnHomePageContent} />
      </MetaTag>

      <HomePageBanner />
      <HomePageIntroSection />
      <HomePageInfoIconsSection />
      <ParticipatingBrands brandIcons={ImgLinks} />
      <Carousel slides={carouselDataVn} header={carouselHeaderVn} />
    </>
  );
};

export default HomePage;
